export interface LifecycleSafetyOptions {
  windowTarget: Pick<Window, "addEventListener" | "removeEventListener">;
  documentTarget: Pick<Document, "addEventListener" | "removeEventListener"> & { visibilityState: DocumentVisibilityState };
  stopRecording: (reason: string) => void;
  cancelTurn: (reason: string) => void;
  isRecordingActive: () => boolean;
}

export function installLifecycleSafety(options: LifecycleSafetyOptions): () => void {
  const onBlur = (): void => {
    if (options.isRecordingActive()) options.stopRecording("window-blur");
  };
  const onVisibility = (): void => {
    if (options.documentTarget.visibilityState !== "hidden") return;
    if (options.isRecordingActive()) options.stopRecording("page-hidden");
    options.cancelTurn("page-hidden");
  };
  const onPageHide = (): void => {
    if (options.isRecordingActive()) options.stopRecording("pagehide");
    options.cancelTurn("pagehide");
  };
  options.windowTarget.addEventListener("blur", onBlur);
  options.documentTarget.addEventListener("visibilitychange", onVisibility);
  options.windowTarget.addEventListener("pagehide", onPageHide);
  return () => {
    options.windowTarget.removeEventListener("blur", onBlur);
    options.documentTarget.removeEventListener("visibilitychange", onVisibility);
    options.windowTarget.removeEventListener("pagehide", onPageHide);
  };
}

